<div class="com-component">
  <dsy-card class="card-container" [noPadding]="true">
    <div class="card-content">
      <div class="offers-component">
        <div class="offers-component__card">
          <div class="offers-component__title">
            <dr-flex-home-ui-widget-header [title]="'FLEX_HOME.COM_WIDGET.OFFERS.TITLE' | translate" [customRightWidget]="true">
              <dsy-icon
                customRightWidget
                class="offers-component__info-icon"
                pTooltip="{{ 'FLEX_HOME.COM_WIDGET.OFFERS.TOOLTIP' | translate }}"
                tooltipPosition="bottom"
                [name]="'info'"
                [size]="'0.8rem'"
              ></dsy-icon>
            </dr-flex-home-ui-widget-header>
          </div>

          @if (tableData() === null) {
            <div class="loading-spinner">
              <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
            </div>
          } @else if (tableData()!.length === 0) {
            <dr-flex-home-ui-empty-state [showPermissionStatus]="true" [title]="'FLEX_HOME.COMMON.NO_DATA'"></dr-flex-home-ui-empty-state>
          } @else {
              <dsy-table class="offers-table" [data]="tableData()" [conf]="tableConf()">
                @for (column of columnsDefinition; track $index) {
                  <p [attr.slot]="`header-${column.key}`" class="offers-table__header">
                    {{ column.header | translate }}
                  </p>
                }
                @for (offer of offers(); track $index) {
                  <p slot="cell-{{ $index }}-site" class="offers-table__text2" pTooltip="{{ offer.siteName | displayLocale: offer.defaultLocale : 'label' }}">
                    {{ offer.siteName | displayLocale: offer.defaultLocale : 'label' }}
                  </p>
                  <p slot="cell-{{ $index }}-program" class="offers-table__text2" pTooltip="{{ offer.programName | displayLocale: offer.defaultLocale : 'label' }}">
                    {{ offer.programName | displayLocale: offer.defaultLocale : 'label' }}
                  </p>

                  <div slot="cell-{{ $index }}-time">
                    @let result = offer.offerStartDttmUtc | formatTimeRange: offer.offerEndDttmUtc;
                    <p class="offers-table__text">
                      {{ result.range }}
                    </p>
                    <p class="offers-table__sub-text">
                      {{ result.timeZone }}
                    </p>
                  </div>

                  <p slot="cell-{{ $index }}-value" class="offers-table__text">
                    {{ offer.offerValue[0].value }}
                  </p>
                }
              </dsy-table>
            <dr-flex-home-ui-link-button
              class="offers-component__button"
              [link]="{ text: ('FLEX_HOME.COM_WIDGET.GO_TO_COM' | translate), href: comUrl, allowRightClick: true }"
              size="md"
              [mixpanelClickEvent]="mixPanelEvent.CLICK_GO_COM"
            />
          }
        </div>
      </div>
    </div>
  </dsy-card>
</div>
